import { createStore } from 'react-hookstore';

export const userProfileStore = createStore('userProfileStore', null);
